// extracted by mini-css-extract-plugin
module.exports = {"feedbackFormContainer":"FeedbackForm_feedbackFormContainer__1FS3T","feedbackForm":"FeedbackForm_feedbackForm__3rJI5"};